function modalGame(audioMain) {
  // Show Modal
const openModalButton = document.getElementById("open-modal");
const modalWindowOverlay = document.getElementById("modal-overlay");
const mainPageButton = document.getElementById("main-page");
const cenaCheckbox = document.getElementById('sound');
const modalGame = document.getElementById('modal-game');
const modalScore = document.getElementById('modal-score');


const showModalWindow = () => {
  modalWindowOverlay.style.display = 'flex';
  audioMain.pause();
  cenaCheckbox.checked = true;

  modalGame.style.display = 'block';
  modalScore.style.display = 'none';
}

openModalButton.addEventListener("click", showModalWindow);

// Hide Modal
const closeModalButton = document.getElementById("main-page");

const hideModalWindow = () => {
  modalWindowOverlay.style.display = 'none';
  audioMain.play();
  cenaCheckbox.checked = false;

  modalGame.style.display = 'block';
  modalScore.style.display = 'none';
}

closeModalButton.addEventListener("click", hideModalWindow);
mainPageButton.addEventListener("click", hideModalWindow);

// Hide On Blur
const hideModalWindowOnBlur = (e) => {
  if(e.target === e.currentTarget) {
    console.log(e.target === e.currentTarget)
    hideModalWindow();
  }
}

mainPageButton.addEventListener("click", hideModalWindowOnBlur)

}

export default modalGame;